'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'sword';
var width = 576;
var height = 512;
var aliases = [128481];
var unicode = 'f71c';
var svgPathData = ['M27.6 448l16-16 32 0 2.3-2.3 56-56 3.5-3.5-1.6-4.7-30.4-91.3 14.8-14.8 164.7 164.7-14.8 14.8-91.3-30.4-4.7-1.6-3.5 3.5-56 56-2.3 2.3 0 32-16 16-68.7-68.7zM177.3 293.7l293.7-293.7 73.4 0 0 73.4-293.7 293.7-73.4-73.4z', 'M177.3 293.7l293.7-293.7 73.4 0 0 73.4-293.7 293.7-73.4-73.4zM262 378.3l298.3-298.3 0-96-96 0-298.3 298.3-40-40-5.7-5.7c-.7 .7-10.6 10.6-29.7 29.7l-3.5 3.5 1.6 4.7 30.4 91.3-50.2 50.2-32 0-2.3 2.3C15.6 437.4 5.7 447.3 5 448l5.7 5.7 80 80 5.7 5.7c.7-.7 10.6-10.6 29.7-29.7l2.3-2.3 0-32 50.2-50.2 91.3 30.4 4.7 1.6 3.5-3.5c19.1-19.1 28.9-28.9 29.7-29.7l-5.7-5.7-40-40zM135.9 365.5l-30.4-91.3 14.8-14.8 164.7 164.7-14.8 14.8-91.3-30.4-4.7-1.6-3.5 3.5-56 56-2.3 2.3 0 32-16 16-68.7-68.7 16-16 32 0 2.3-2.3 56-56 3.5-3.5-1.6-4.7z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSword = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;